<template>
   <div>
        <div class="container pb-5 goUp">
            <SectionTitle title="Videos"/><br> 
            <div class="row">
                <div v-for="(video,index) in videos" :key="index" class="col-sm-4">
                    <div class="card mb-4">
                        <div class="card-body">
                            <div class="embed-responsive embed-responsive-21by9">
                                <iframe width="1280" height="720" :src="video.link" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                            <p class="pt-2 text-muted text-center" style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden;" :title="video.tilulo">{{ video.tilulo}}</p>
                            <button class="btn btn-info" data-toggle="modal" :data-target="`#video-` + index">Ver video</button>
                        </div>
                    </div>
                </div>               
            </div>
            <!-- Modal -->
            <div  v-for="(video,index) in videos" :key="index" class="modal fade bd-example-modal-xl" :id="'video-' + index" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="embed-responsive embed-responsive-16by9">
                                <iframe width="1280" height="720" :src="video.link" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
   </div>
</template>
<script>
    export default {
        data(){
            return {
                videos:[
                    { link: 'https://www.youtube.com/embed/1dta68Y8oLQ', tilulo:'La detección por trampeo permite ubicar la plaga en su estado adulto.'},
                    { link: 'https://www.youtube.com/embed/c8n136-zfYY', tilulo:'Peten área libre de mosca del Mediterráneo.'},
                    { link: 'https://www.youtube.com/embed/C3_fXnmudkc', tilulo:'Apoyo al sector apícola.'},
                    { link: 'https://www.youtube.com/embed/HPPQbNjp6fw', tilulo:'Apoyo a la Meliponicultura.'},
                    { link: 'https://www.youtube.com/embed/NBPiVPtdfDU', tilulo:'Apicultura Moscamed nuestro diario.'},
                    { link: 'https://www.youtube.com/embed/RQ-Wsd3lKp0', tilulo:'La detección por muestreo permite ubicar la plaga en su estado inmaduro'},
                    { link: 'https://www.youtube.com/embed/mUlvJ_tpfUE', tilulo:'El Programa Moscamed a través del Centro de Empaque de Adulto Frío, CEAF, realiza la liberación en campo de mosca del Mediterráneo estéril, reduciendo las poblaciones y generando Áreas Libres de la plaga en Guatemala'},
                    { link: 'https://www.youtube.com/embed/ZWNBi-IfhaA', tilulo:'Los Puestos de Cuarentena protegen el Area Libre de mosca del Mediterráneo con reconocimiento internacional de Petén'},
                    { link: 'https://www.youtube.com/embed/5dHtAwOLkOA', tilulo:'Moscamed Area Libre Petén'},
                    { link: 'https://www.youtube.com/embed/UpKebSVjIRg', tilulo:'La detección y control de la mosca del mediterraneo, MAM.'},
                    { link: 'https://www.youtube.com/embed/fnfl69Xu9tM', tilulo:'La detección y control de la mosca del mediterraneo, POPTI.'},
                    { link: 'https://www.youtube.com/embed/MHOBqccUauc', tilulo:'Moscamed AIEA (Español)'},
                    { link: 'https://www.youtube.com/embed/RTn2CWFdnCg', tilulo:'Moscamed AIEA (Inglés)'},
                    { link: 'https://www.youtube.com/embed/QCytMAL6NOI', tilulo:'Moscamed Natgeo (Inglés)'},
                    { link: 'https://www.youtube.com/embed/8wKUzh1tiaM', tilulo:'Programa Moscamed PIU Oct 2020'},
                    { link: 'https://www.youtube.com/embed/KdUXre_-vCo', tilulo:'Manejo adecuado del GPS'},
                    { link: 'https://www.youtube.com/embed/8Imm1nlhCLE', tilulo:'Trabajos multinacionales'},
                    { link: 'https://www.youtube.com/embed/LA4Z1u-uGZ0', tilulo:'Moscamed Visión Rural'},
                    { link: 'https://www.youtube.com/embed/1SncQ03XzwY', tilulo:'Producción y liberación'},
                    { link: 'https://www.youtube.com/embed/n1kuxO-1BL0', tilulo:'Curso intrarregional 2019'},
                    { link: 'https://www.youtube.com/embed/BlKe9570cIo', tilulo:'Curso intrarregional 2017'},
                    { link: 'https://www.youtube.com/embed/92wB9rtZSLk', tilulo:'Curso intrarregional 2015'},
                    { link: 'https://www.youtube.com/embed/ZuKg9wGW1uc', tilulo:'Centro apícola'},
                ]
            }
        }
    }
</script>

